module.exports = __webpack_public_path__ + "img/account-setting-icon-active.a1072a57.svg";